import ShippingDetails from './ScannedItemCard/ShippingDetails';
import CardIdentifier from './ScannedItemCard/CardIdentifier';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { ScannedCheckpointItem } from '../../models';
import { IconButton } from '@mui/material';
import { appUrl } from '@/utils/appUrl';

interface ScannedItemCardProps {
  item: ScannedCheckpointItem;
  index: number;
  onRemove: (number: string) => void;
}

const ScannedItemCard = ({ item, index, onRemove }: ScannedItemCardProps) => {
  const openShippingDetails = () => {
    window.open(
      appUrl(`/business/shipping/${item.number}`),
      '_blank'
    );
  };

  return (
    <div className='grid grid-cols-[1fr_2fr_auto] items-center gap-4 p-4 rounded-xl border border-gray-100'>
      <CardIdentifier
        index={index}
        shippingNumber={item.number}
        serviceType={item.serviceType}
        onOpenDetails={openShippingDetails}
      />

      <ShippingDetails
        destinationAddress={item.destinationAddress}
        customerName={item.customerName}
        commerceName={item.commerceName}
      />

      <div className='flex justify-end'>
        <IconButton
          onClick={() => onRemove(item.number)}
          size='small'
          title='Quitar del listado'
        >
          <DeleteIcon fontSize='small' />
        </IconButton>
      </div>
    </div>
  );
};

export default ScannedItemCard;
